// Firebase configuration and initialization for The Bey Mojito menu app
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDK4eWrFqdlGnf7nkVBfIHr8JBZ_E5wSlU",
  authDomain: "waelmenu.firebaseapp.com",
  projectId: "waelmenu",
  storageBucket: "waelmenu.firebasestorage.app",
  messagingSenderId: "322820056326",
  appId: "1:322820056326:web:6462582864d6c47df72a87"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth }; 